import React, { useState } from 'react';
import { axiosInstanceV2 } from '../../services/axios';

function Developer() {
	const [loading, setLoading] = useState({
		sync_plan: false,
	});

	const handleSyncPlans = async () => {
		try {
			setLoading((prev) => ({
				...prev,
				sync_plan: true,
			}));

			await axiosInstanceV2.get('/razorpay/sync-plans');
		} catch (error) {
			console.log(error);
		} finally {
			setLoading((prev) => ({
				...prev,
				sync_plan: false,
			}));
		}
	};

	return (
		<div className="container my-2">
			<div>
				<h5>Sentry Testing</h5>
				<div>
					<button
						onClick={() => {
							throw new Error('Sentry Test');
						}}
					>
						Test Error
					</button>
				</div>
			</div>
			<div>
				<h5>Subscription / Plans API's</h5>
				<button onClick={handleSyncPlans}>
					{loading.sync_plan ? 'Syncing Plan...' : 'Sync Plans'}
				</button>
			</div>
		</div>
	);
}

export default Developer;
